angular.module('mobilezuz').directive('spUnitWeight', [
    '$rootScope',
    'spUnits',
    function ($rootScope, spUnits) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                product: '=',
                productId: '=?',
                cartLine: '=?',
                onWeight: '&?',
                onUnit: '&?',
                source: '@',
            },
            templateUrl: 'views/templates/sp-unit-weight.html',
            controller: [
                '$scope',
                'User',
                '$q',
                'Api',
                'Util',
                'Config',
                'SpCartService',
                function ($scope, user, $q, api, Util, Config, spCartService) {
                    var _listeners = [];
                    var spUnitWeightCtrl = this;

                    spUnitWeightCtrl.onUnitClick = onUnitClick;
                    spUnitWeightCtrl.onWeightClick = onWeightClick;
                    spUnitWeightCtrl.language = Config.language.id;
                    spUnitWeightCtrl.user = user;
                    spUnitWeightCtrl.unitOfMeasure = Config.defaultWeightUnitNames[spUnitWeightCtrl.language];

                    _listeners.push(
                        $scope.$watch(
                            function () {
                                return Config.language.id;
                            },
                            function (newCulture, oldCulture) {
                                spUnitWeightCtrl.language = newCulture;
                            }
                        )
                    );

                    _init();

                    function onUnitClick() {
                        if ($scope.onUnit && $scope.onUnit()) return;
                        if ($scope.product.soldBy === $rootScope.PRODUCT_DISPLAY.WEIGHT.name) {
                            $rootScope.$emit(
                                'product.changeUnits',
                                { product: $scope.product },
                                {
                                    source: $scope.source,
                                    previousUnit: spUnitWeightCtrl.unitOfMeasure[spUnitWeightCtrl.language],
                                    newUnit: $rootScope.PRODUCT_DISPLAY.UNIT.name,
                                }
                            );
                            if (!$scope.cartLine) {
                                $scope.product.soldBy = $rootScope.PRODUCT_DISPLAY.UNIT.name;
                                return;
                            }
                            $scope.product.soldBy = $rootScope.PRODUCT_DISPLAY.UNIT.name;
                            $scope.cartLine.soldBy = $rootScope.PRODUCT_DISPLAY.UNIT.name;
                            $scope.cartLine.product.soldBy = $rootScope.PRODUCT_DISPLAY.UNIT.name;

                            /* if need to re-calculate the quantity from weight to unit when switching to unit, uncomment this code */
                            // $scope.cartLine.oldQuantity = Math.round($scope.cartLine.oldQuantity / $scope.product.weight);
                            // $scope.cartLine.quantity = Math.round($scope.cartLine.quantity / $scope.product.weight);

                            $scope.cartLine.oldQuantity = Math.ceil($scope.cartLine.oldQuantity);
                            $scope.cartLine.quantity = Math.ceil($scope.cartLine.quantity);
                        }
                    }

                    function onWeightClick() {
                        if ($scope.onWeight && $scope.onWeight()) return;
                        if ($scope.product.soldBy === $rootScope.PRODUCT_DISPLAY.UNIT.name) {
                            $rootScope.$emit(
                                'product.changeUnits',
                                { product: $scope.product },
                                {
                                    source: $scope.source,
                                    previousUnit: $rootScope.PRODUCT_DISPLAY.UNIT.name,
                                    newUnit: spUnitWeightCtrl.unitOfMeasure[spUnitWeightCtrl.language],
                                }
                            );
                            if (!$scope.cartLine) {
                                $scope.product.soldBy = $rootScope.PRODUCT_DISPLAY.WEIGHT.name;
                                return;
                            }
                            $scope.product.soldBy = $rootScope.PRODUCT_DISPLAY.WEIGHT.name;
                            $scope.cartLine.soldBy = $rootScope.PRODUCT_DISPLAY.WEIGHT.name;
                            $scope.cartLine.product.soldBy = $rootScope.PRODUCT_DISPLAY.WEIGHT.name;

                            spUnitWeightCtrl.unitOfMeasure = Config.defaultWeightUnitNames;

                            var unit = $scope.cartLine.isCase ? null : Util.getProductUnit($scope.cartLine.product, $scope.cartLine.soldBy);
                            var interval = spCartService.quantityInterval($scope.cartLine, $scope.cartLine.soldBy);
                            var intervalInUnit = unit ? spUnits.convert(interval, $rootScope.defaultWeighableUnit, { to: unit }).value : interval;
                            intervalInUnit = _roundNumber(intervalInUnit);
                              
                            $scope.cartLine.oldQuantity = _roundNumber(Math.ceil(_roundNumber($scope.cartLine.oldQuantity * $scope.product.weight / intervalInUnit)) * intervalInUnit);
                            $scope.cartLine.quantity = _roundNumber(Math.ceil(_roundNumber($scope.cartLine.quantity * $scope.product.weight / intervalInUnit)) * intervalInUnit);
                        }
                    }

                    function _init() {
                        spUnitWeightCtrl.unitOfMeasure = Config.defaultWeightUnitNames;
                    }

                    function getLine(product) {
                        return Util.getProductCartLine(product, product.isCaseMode);
                    }

                    function _roundNumber(number) {
                        var rounded = Number(number.toFixed(2));
                        return Number.isInteger(rounded) ? parseInt(rounded) : rounded;
                      }

                    _listeners.push(
                        $scope.$watch('cartLine.soldBy', function (newSoldBy, oldSoldBy) {
                            if (!!newSoldBy && $scope.product.soldBy !== newSoldBy) {
                                $scope.product.soldBy = newSoldBy;
                            }
                        })
                    );

                    _listeners.push(
                        $scope.$watch('product.soldBy', function (newSoldBy, oldSoldBy) {
                            if (!!newSoldBy && $scope.product.soldBy !== newSoldBy) {
                                $scope.product.soldBy = newSoldBy;
                            }
                        })
                    );

                    Util.destroyListeners($scope, _listeners);
                },
            ],
            controllerAs: 'spUnitWeightCtrl',
        };
    },
]);
